import { calculateDuration, calculateEndDate, type DateCalculationState } from './dateUtils';

export type DateDurationSyncConfig = {
    getStartDate: () => Date | string | null | undefined;
    getEndDate: () => Date | string | null | undefined;
    getDuration: () => string | null | undefined;
    setEndDate: (date: Date) => void;
    setDuration: (duration: string) => void;
    isActive?: () => boolean;
};

/**
 * Sets up reactive date/duration auto-calculation.
 * When start + duration change, end date is recalculated.
 * When start + end change, duration is recalculated.
 *
 * Must be called during component initialization (top-level of <script> block).
 */
export function createDateDurationSync(config: DateDurationSyncConfig): void {
    let dateState = $state<DateCalculationState>({
        prevStartDate: null,
        prevEndDate: null,
        prevDuration: '',
    });

    // Auto-calculate end date when start date or duration changes
    $effect(() => {
        if (config.isActive && !config.isActive()) return;

        const result = calculateEndDate(config.getStartDate(), config.getDuration(), dateState);

        if (result) {
            config.setEndDate(result.endDate);
            dateState = result.newState;
        }
    });

    // Auto-calculate duration when end date changes
    $effect(() => {
        if (config.isActive && !config.isActive()) return;

        const result = calculateDuration(config.getStartDate(), config.getEndDate(), dateState);

        if (result) {
            config.setDuration(result.duration);
            dateState = result.newState;
        }
    });
}
